import { Box, Button, Modal, Paper, Typography, useMediaQuery } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import HelpIcon from '@mui/icons-material/Help'
import React from 'react'
import { HelperModalProps } from '../types'
import { useTheme } from '@mui/material/styles';
import useStyles from "../styles/HelperModal.styles"
import clsx from 'clsx'

export const HelperModalView: React.FC<HelperModalProps> = ({ text, header }) => {
    const classes = useStyles()
    const theme = useTheme()
    const isPortableDevice = useMediaQuery(theme.breakpoints.down('md'))
    const [open, setOpen] = React.useState(false)

    if (!text) return <></>

    return (
        <>
            <Button onClick={() => setOpen(true)} variant='text' size='small' className={classes.helpIconBtn}>
                <HelpIcon></HelpIcon>
            </Button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
                disableScrollLock
            >
                <Paper className={clsx(classes.modal, {[classes.modalSmall]: isPortableDevice})}>
                    <Box className={classes.dialogTitle}>
                        <h2>{header || 'Nápověda'}</h2>
                        <Button onClick={() => setOpen(false)}>
                            <CloseIcon className={classes.closeIcon} />
                        </Button>
                    </Box>
                    <Box paddingBottom={3} paddingLeft={3} paddingRight={3} className={classes.contentBox}>
                        <Typography variant='body1' component='div'>
                            <p dangerouslySetInnerHTML={{ __html: text }}></p>
                        </Typography>
                    </Box>
                </Paper>
            </Modal>
        </>
    )
}

export default HelperModalView
